const toMinutesNumber = (minutesString: string): number => {
  const numericMinutes = Number(minutesString);
  if (isNaN(numericMinutes)) {
    return 0;
  }
  if (numericMinutes < 10) {
    return numericMinutes * 10;
  }
  return numericMinutes;
};

const toMinutesStringQuarter = (minutes: number) => {
  if (minutes < 10) {
    return '00';
  }
  if (minutes > 45) {
    return '45';
  }
  const roundedMinutes = (Math.round(minutes / 15) * 15) % 60;
  return roundedMinutes.toString();
};

const toValidHourString = (hour: string) => {
  const numericHour = Number(hour);
  if (isNaN(numericHour)) return '00';
  return numericHour < 10 ? `0${numericHour}` : `${numericHour}`;
};

export const getNearestTimeOptionLabel = (timeValue: string): string => {
  const [hour, rest = 'mm: aa'] = timeValue.split(':');
  const validHour = toValidHourString(hour);
  const [minutes, ampm] = rest.split(' ');
  const numericMinutes = toMinutesNumber(minutes);
  const stringMinutes = toMinutesStringQuarter(numericMinutes);
  return `${validHour}:${stringMinutes}${ampm === 'PM' ? 'PM' : 'AM'}`;
};

/**
 * Calculates the scroll index for the time picker dropdown.
 * Returns the index to scroll to 9:00 AM by default, or the first available
 * time if minTime filters out 9:00 AM.
 *
 * @param totalSlots - Total number of time slots (96 for 24 hours with 15-min intervals)
 * @param optionsLength - Number of options after minTime filtering
 * @param defaultHour - The default hour to scroll to (e.g., 9 for 9:00 AM)
 * @param slotsPerHour - Number of slots per hour (4 for 15-min intervals)
 * @returns The index to scroll to
 */
export const getDefaultScrollIndex = (
  totalSlots: number,
  optionsLength: number,
  defaultHour: number,
  slotsPerHour: number
): number => {
  const filteredSlots = totalSlots - optionsLength;
  const targetIndex = defaultHour * slotsPerHour - filteredSlots;
  return Math.max(0, targetIndex);
};
